import { TThunkAction } from '../../types/redux';
import { openChatModal, IOpenChatModalPayload } from '../chatModal';

export function chatAuthSucceed(payload: IOpenChatModalPayload) {
  return (): TThunkAction => {
    return dispatch => {
      dispatch(openChatModal(payload));
    };
  };
}
